module.exports = __webpack_public_path__ + "ProximaNova-Semibold.a9f4f007ee68fc12b8977061e6660cef.woff2";